import { useTranslation } from 'react-i18next';
import { Chip, Popover } from '@c2fo/liquidity';

interface ClearStatusChipProps {
  isPendingClear: boolean;
}

const ClearStatusChip = ({ isPendingClear }: ClearStatusChipProps) => {
  const { t } = useTranslation();

  return (
    <Popover>
      <Popover.Trigger>
        <Chip
          size="xs"
          type={isPendingClear ? 'default' : 'primary'}
          label={isPendingClear ? t('core.history.statusPending') : t('core.history.statusAwarded')}
          isRound
          variant="outlined"
        />
      </Popover.Trigger>
      <Popover.Content arrow side="right">
        <div className="w-52 text-center text-sm">
          {isPendingClear ? t('taker.history.statusPendingTooltip') : t('taker.history.statusAwardedTooltip')}
        </div>
      </Popover.Content>
    </Popover>
  );
};

export default ClearStatusChip;
